module.exports = __webpack_public_path__ + "img/ganbudangan.667d5e71.png";